// Free post-call decision flow (Lock it In / Next card) — no paywall after a vibe check.
// Monetisation is handled by per-user 1-month trial + daily caps (see /api/usage + UpgradeSheet).
export const FREE_PERIOD = true;
